import type {
    JitsiAnticsEvent,
    JitsiAnticsMetricContext,
    JitsiAnticsMetricFields,
} from 'antics/types'
import {createAsyncThunk} from '@reduxjs/toolkit'
import ninchatClient from 'api/NinchatClient'

const actionTypePrefix = 'NINCHAT/action'

export type SendJitsiMetricPayload = {
    context?: JitsiAnticsMetricContext
    event: JitsiAnticsEvent
    fields?: JitsiAnticsMetricFields
}

export const sendJitsiMetric = createAsyncThunk<void, SendJitsiMetricPayload>(
    `${actionTypePrefix}/sendJitsiMetric`,
    ({
        context,
        event,
        fields,
    }, {rejectWithValue}) => {
        try {
            ninchatClient.sendJitsiMetric(event, context, fields)
            return undefined
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
